export const LOAD_TOP_TAGS = 'LOAD_TOP_TAGS';
export const LOAD_TOP_TAGS_SUCCESS = 'LOAD_TOP_TAGS/SUCCESS';
export const LOAD_TOP_TAGS_ERROR = 'LOAD_TOP_TAGS/ERROR';
export const CHANGE_PAGE = 'CHANGE_PAGE';
